import { translationKey } from '@change-corgi/core/i18n';

export const BadgesTypes = {
	GREAT: {
		labelKey: translationKey('corgi.components.badge_score.variants.great'),
		backgroundColor: '#B8FEB9',
		color: '#075208',
		stroke: '#22C024',
	},
	GOOD: {
		labelKey: translationKey('corgi.components.badge_score.variants.good'),
		backgroundColor: '#EEFFF5',
		color: '#0C5B2D',
		stroke: '#0DDA62',
	},
	ROOM_TO_IMPROVE: {
		labelKey: translationKey('corgi.components.badge_score.variants.room_to_improve'),
		backgroundColor: '#FFE3A8',
		color: '#7E3B10',
		stroke: '#FE9311',
	},
	BELOW_AVERAGE: {
		labelKey: translationKey('corgi.components.badge_score.variants.below_average'),
		backgroundColor: '#FFFEC7',
		color: '#9D6A0B',
		stroke: '#FFCE71',
	},
} as const;

export type BadgeType = (typeof BadgesTypes)[keyof typeof BadgesTypes];
